import { useState, useEffect } from 'react';

const useMediaQuery = (query) => {
  // Initialize with the actual value to prevent flicker
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    const media = window.matchMedia(query);

    // Set initial value (in case it changed)
    setMatches(media.matches);

    // Create event listener
    const listener = (e) => setMatches(e.matches);

    // Add listener
    media.addEventListener('change', listener);

    // Cleanup
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
};

export default useMediaQuery;
